import {createContext,useContext} from 'react';

const RootContext = createContext();

export const Provider = RootContext.Provider;

export default function useRoot(){
  return useContext(RootContext);
}